import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../api/services";

export const fetchAccountDeatils: any = createAsyncThunk(
  "account/accountDetaila",
  async (id: any) => {
    const response = await API.get(`account-details?account_id=${id}`);
    return response?.data;
  }
);

const initialState = {
    accountDetails: null
};

const accountDetailSlice = createSlice({
    name: 'account',
    initialState,
    reducers:{
        setAccountDetailsState: (state, {payload}) =>{
            state.accountDetails = payload;
        },
        cleanAccountDetailsState: (state) =>{
            state.accountDetails = null;
        }
    }
});
export const {setAccountDetailsState, cleanAccountDetailsState} = accountDetailSlice.actions;
export default accountDetailSlice.reducer;
